"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireWildcard(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = {
  PropTypes: {
    items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      label: _propTypes.default.string,
      value: (0, _propTypes.oneOfType)([_propTypes.default.string, _propTypes.default.number])
    })).isRequired,
    label: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    onValueChange: _propTypes.default.func,
    onClick: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    value: _propTypes.default.string,
    showPicker: _propTypes.default.bool,
    enablePaxAgeUpdate: _propTypes.default.bool
  },
  DefaultProps: {
    label: '',
    value: '',
    placeholder: '',
    showPicker: false,
    onValueChange: function onValueChange() {},
    onBlur: undefined,
    onClick: undefined,
    enablePaxAgeUpdate: false
  }
};
exports.default = _default;